import { MutableRefObject } from 'react';

export const THRESHOLD_50 = 50;

export const reachedEndOfList = (
  listRef: MutableRefObject<HTMLElement | null>,
  threshold: number
) => {
  if (!listRef.current) return false;
  const { scrollHeight, offsetHeight, scrollTop, clientHeight } =
    listRef.current;

  if (scrollHeight <= clientHeight || scrollHeight === 0) return true;

  const height = scrollHeight - offsetHeight;
  const diff = height - Math.abs(scrollTop);
  return diff < threshold;
};
